import { componentQrl, inlinedQrl, _jsxS, _fnSignal } from "@builder.io/qwik";
const Textarea = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxS("textarea", {
    ...props.attributes
  }, {
    defaultValue: _fnSignal((p0) => p0.defaultValue, [
      props
    ], "p0.defaultValue"),
    name: _fnSignal((p0) => p0.name, [
      props
    ], "p0.name"),
    placeholder: _fnSignal((p0) => p0.placeholder, [
      props
    ], "p0.placeholder"),
    required: _fnSignal((p0) => p0.required, [
      props
    ], "p0.required"),
    value: _fnSignal((p0) => p0.value, [
      props
    ], "p0.value")
  }, 0, "kE_0");
}, "Textarea_component_o1TcxV139Oc"));
export {
  Textarea,
  Textarea as default
};
